import React, {useMemo} from 'react';
import ReactSlider from 'react-slider';
import './RangeSlider.css';

const classNames = (...classes) => classes.filter(Boolean).join(' ');
const RangeSlider = ({
                         values,
                         value,
                         onChange,
                         disabled = false
                     }) => {
    const currentIndex = useMemo(() => {
        const index = values.indexOf(value);
        return index === -1 ? 0 : index;
    }, [value, values]);

    const handleChange = (index) => {
        if (index >= 0 && index < values.length) {
            onChange(values[index]);
        }
    };


    return (
        <div className="range-slider-container">
            <div className="track-container">
                <div className="slider-container-inner">
                    <ReactSlider
                        className="custom-slider"
                        thumbClassName="custom-thumb"
                        renderTrack={(props, state) => (
                            <div
                                {...props}
                                style={{
                                    ...props.style,
                                    height: '2.677vw',
                                    borderRadius: '52px',
                                    cursor: 'pointer'
                                }}
                                className={classNames(
                                    state.index === 0 ? 'bg-blue-filled' : 'bg-gray-unfilled'
                                )}
                            />
                        )}
                        min={0}
                        max={values.length - 1}
                        value={currentIndex}
                        onChange={handleChange}
                        step={1}
                        disabled={disabled}
                        renderThumb={(props, state) => (
                            <div
                                {...props}
                                style={{
                                    ...props.style,
                                    width: `2.864vw`,
                                    height: `2.864vw`,
                                    backgroundColor: '#fff',
                                    border: '4px solid #006cfa',
                                    borderRadius: '50%',
                                    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)',
                                    opacity: disabled ? 0.6 : 1,
                                    cursor: disabled ? 'not-allowed' : 'pointer',
                                    transition: 'box-shadow 0.3s, transform 0.3s',
                                    zIndex: 3
                                }}
                            />
                        )}
                    />
                </div>
            </div>
        </div>
    );
};

export default RangeSlider;
